import { loadStripe } from "@stripe/stripe-js";
import { useMemo } from "react";

import { env } from "../../../common/lib/env";
import { Modal } from "../../../common/Atoms/Modal";
import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";

import { EmbeddedCheckoutFrame } from "./EmbeddedCheckoutFrame";

interface StripeSetupCheckoutProps {
  clientSecret: string;
  connectedAccountId: string;
  onClose: () => void;
  description?: string;
}

export function StripeSetupCheckout({
  clientSecret,
  connectedAccountId,
  onClose,
  description = `Add a payment method to automatically pay the plan installments. Surcharges may apply`,
}: StripeSetupCheckoutProps) {
  const stripePromise = useMemo(() => {
    return loadStripe(env.stripePublicKey, {
      stripeAccount: connectedAccountId,
    });
  }, [connectedAccountId]);

  return (
    <Modal
      open={ true }
      setOpen={ onClose }
      title={ `` }
      width={ `stripe` }
    >
      <Paragraph className={ `mb-3` }>
        { description }
      </Paragraph>
      <EmbeddedCheckoutFrame
        stripePromise={ stripePromise }
        clientSecret={ clientSecret }
      />
    </Modal>
  );
}
